<script setup lang="ts">
import Chip from '@/components/Chip.vue';
import type { RouteLocationRaw } from 'vue-router';

const props = withDefaults(
    defineProps<{
        routeTo: RouteLocationRaw;
        icon: string;
        displayText: string;
        /**
         * This adds a class to the icon
         * Default is text-main
         */
        iconClass?: string;
        spanClass?: string;
    }>(),
    {
        iconClass: 'text-lg',
        spanClass: 'text-md'
    }
);
</script>

<template>
    <Chip color="main-dark" :to="props.routeTo" :ripple="false" @click.stop>
        <v-icon :icon="props.icon" class="mr-1" :class="iconClass" />
        <span :class="spanClass">{{ props.displayText }}</span>
    </Chip>
</template>
